<template>
  <div class="row">
    <div class="col-12">
      <div class="card card-body">
        <div class="col-12 table-responsive">
          <table class="table table-hover table-sm table-bordered">
            <thead>
              <th>
                العميل
              </th>
              <th>
                رقم الطلب
              </th>
              <th>
                التاريخ
              </th>
              <th>
                الخطة
              </th>
              <th>
                الأشهر
              </th>
              <th>
                تاريخ انتهاء الاشتراك
              </th>
              <th>
                الحالة
              </th>
            </thead>
            <tbody>
              <tr v-for="device in users" :key="device._id">
                <td>
                  {{ device.name }}
                </td>
                <td>
                  {{ device.order_id }}
                </td>
                <td>
                  {{ device.date }}
                </td>
                <td>
                  <span class="btn btn-sm btn-secondary" v-if="device.plan == 1">الفضية</span>
                  <span class="btn btn-sm btn-success" v-if="device.plan == 2">الذهبية</span>
                  <span class="btn btn-sm btn-primary" v-if="device.plan == 3">الالماسية</span>
                  <span class="btn btn-sm btn-outline-danger" v-if="device.plan == 0">لم يشترك</span>
                </td>
                <td>
                  {{ device.months }}
                </td>
                <td>
                  {{ device.exdate }}
                </td>
                <td>
                    <span class="btn btn-sm btn-warning" style="paddixng: 2px" v-if="device.status == 0 || !device.status">
                        <i class="fa fa-clock-o"></i> في الانتظار
                    </span>
                    <span class="btn btn-sm btn-success" style="paddxing: 2px" v-if="device.status == 1">
                        <i class="fa fa-check"></i> تم بنجاح
                    </span>
                    <span class="btn btn-sm btn-danger" style="paddixng: 2px" v-if="device.status == 2">
                        <i class="fa fa-times"></i> ملغي
                    </span>
                  <a href="javascript:;" class="fa fa-edit" @click="edit(device._id, 'status', device.status)"></a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      user: JSON.parse(localStorage.getItem('user')),
      users: []
    }
  },
  methods: {
    alertx(r){alert(r)},
    edit(id, input, value){
        var g = this;
        var p = prompt(input, value);
        if(p && p != ""){
            $.post(api + '/admin/orders/edit', {
                jwt: this.user.jwt,
                id: id,
                input: input,
                value: p
            }).then(function(r){
                g.loading = false
                if(r.status != 100){
                    alert(r.response)
                }else{
                    location.reload()
                }
            }).fail(function(){
                g.loading = false
            })
        }
    }
  },
  created(){
    var g = this;
    $.post(api + '/admin/orders', {
        jwt: this.user.jwt
    }).then(function(r){
        g.loading = false
        if(r.status != 100){
            alert(r.response)
        }else{
            g.users = r.response
        }
    }).fail(function(){
        g.loading = false
    })
  },
}
</script>

<style>

</style>